<template>
  <div
    v-if="stepData"
    class="step"
  >
    <component
      :is="question.questionComponent"
      v-for="question in questions"
      :key="question.questionId || question.questionComponent"
      :product-name="productName"
      :step-id="stepId"
      :question-id="question.questionId"
      v-bind="question.params || {}"
      :form-observer="formObserver"
      :form-data="form"
      :step-data="stepData"
      :show-confirm-modal="showConfirmModal"
      :drivers-backup="driversBackup"
      @toast="showToast($event)"
      @input="stepData = { ...stepData, ...$event }"
      @add-driver="$emit('add-driver')"
      @change-driver="$emit('change-driver', $event)"
      @delete-driver="$emit('delete-driver', $event)"
      @backup-additional-drivers="$emit('backup-additional-drivers', $event)"
      @restore-additional-drivers="$emit('restore-additional-drivers', $event)"
      @remove-additional-drivers="$emit('remove-additional-drivers')"
      @additional-drivers-status-check="hasAdditionalDrivers = $event"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from 'lodash';

export default {
  name: 'form-motorhome-step-3',
  props: {
    formObserver: {
      type: Object,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
    driversBackup: {
      type: Array,
      default: null,
    },
    productName: {
      type: String,
      required: true,
    },
    stepId: {
      type: String,
      required: true,
    },
    questions: {
      type: Array,
      required: true,
    },
  },
  inject: ['constants'],
  data () {
    return {
      stepData: null,
      hasAdditionalDrivers: this.form.drivers.length > 1,
    };
  },
  computed: {
    step () {
      return this.form.cover;
    },
  },
  watch: {
    stepData: {
      handler (val) {
        this.$emit('step-data', val);
      },
      immediate: true,
    },
    'formObserver.valid': {
      immediate: true,
      handler (val) {
        if (val) this.$emit('valid');
      },
    },
  },
  async created () {
    this.$emit('tracking', 'cover');
    await this.initStep();
  },
  methods: {
    ...mapActions(['showToast', 'showConfirmModal']),
    async initStep () {
      this.stepData = cloneDeep(this.form.cover);
      if (this.stepData.mainUserOfVehicle > this.form.drivers.length) {
        this.stepData.mainUserOfVehicle = 1;
      }
      this.formObserver.reset();
    },
  },
};
</script>
